import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../react-query/constants";
import { toast } from "react-toastify";
import { toastOptions } from "../utils";
import { getLoginToken } from "../storage";

const addWitness = async (formData: any) => {
  const data = await axiosInstance({
    url: `/thirdPartyApproval/round/${formData?.id}/thirdparty/claim`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

async function getPending() {
  const data = await axiosInstance({
    url: "/thirdPartyApproval/me",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const tpApprove = async (formData: any) => {
  const data = await axiosInstance({
    url: `/thirdPartyApproval/approvals/${formData?.id}/act`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useTPEvidence() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => addWitness(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.tpEvidence]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function usePendingTP() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.tpActions],
    queryFn: () => getPending(),
  });
  return data;
}

export function useTPActions() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => tpApprove(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.tpActions]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
